// externals
import produce from 'immer';
import type { Reducer } from 'redux';

// action types
import {
    REQUEST_PROPOSAL_TOGGLE_DEAL_TYPE,
    REQUEST_PROPOSAL_TOGGLE_INCENTIVE,
    REQUEST_PROPOSAL_UPDATE_NOTES,
    REQUEST_PROPOSAL_RESET,
    UPDATE_DEAL_REQUEST,
    UPDATE_DEAL_SUCCESS,
    UPDATE_DEAL_FAILURE,
    OPEN_REQUEST_CHANGE_MODAL,
    FETCH_DEAL_SUMMARY_PDF_REQUEST,
    FETCH_DEAL_SUMMARY_PDF_SUCCESS,
    FETCH_DEAL_SUMMARY_PDF_FAILURE,
    SHOW_CONFETTI,
    DEAL_PDF_LOADED_SUCCESS,
    FETCH_DEAL_SUCCESS
} from './actionTypes';
import type { RequestProposalState } from '../types';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { getInitialRequestProposalState } from './initialState';

// reducer

export const requestProposalReducer: Reducer<RequestProposalState> = (state = getInitialRequestProposalState(), action: any) =>
    produce(state, (draft) => {
        switch (action.type) {
            case initActionTypes.INIT_PENCIL_SUCCESS: {
                draft.dealPdfUrl = '';
                draft.dealPdfVersion = undefined;
                draft.dealPdfFetchStatus = ApiRequestStatus.Idle;
                break;
            }

            case REQUEST_PROPOSAL_TOGGLE_DEAL_TYPE: {
                const dealType = action.payload;
                draft.selectedDealTypes = dealType;
                break;
            }
            case REQUEST_PROPOSAL_TOGGLE_INCENTIVE: {
                const incentive = action.payload;
                draft.selectedIncentives = incentive;
                break;
            }
            case REQUEST_PROPOSAL_UPDATE_NOTES: {
                draft.notes = action.payload;
                break;
            }
            case UPDATE_DEAL_REQUEST: {
                draft.requestStatus = ApiRequestStatus.Loading;
                break;
            }
            case UPDATE_DEAL_SUCCESS: {
                draft.requestStatus = ApiRequestStatus.Success;
                draft.isRequestChangeModalOpen = false;
                draft.notes = '';
                draft.selectedDealTypes = [];
                draft.selectedIncentives = [];
                // Forces useDealSummaryPdf to refetch instead of showing a stale PDF.
                draft.dealPdfUrl = '';
                break;
            }
            case UPDATE_DEAL_FAILURE: {
                draft.requestStatus = ApiRequestStatus.Error;
                break;
            }
            case REQUEST_PROPOSAL_RESET: {
                draft.requestStatus = ApiRequestStatus.Idle;
                break;
            }
            case OPEN_REQUEST_CHANGE_MODAL: {
                draft.isRequestChangeModalOpen = action.payload;
                break;
            }

            case FETCH_DEAL_SUMMARY_PDF_REQUEST: {
                draft.dealPdfFetchStatus = ApiRequestStatus.Loading;
                draft.dealPdfUrl = '';
                draft.isDealPdfLoading = true;

                break;
            }

            case FETCH_DEAL_SUMMARY_PDF_SUCCESS: {
                draft.dealPdfFetchStatus = ApiRequestStatus.Idle;
                if (action.payload?.data?.pdfUrl) {
                    draft.dealPdfUrl = action.payload.data.pdfUrl;
                    draft.dealPdfVersion = action.meta?.dealXgVersion;
                }
                break;
            }

            case FETCH_DEAL_SUMMARY_PDF_FAILURE: {
                draft.dealPdfFetchStatus = ApiRequestStatus.Error;
                break;
            }

            case SHOW_CONFETTI: {
                draft.showConfetti = action.payload;
                break;
            }
            case DEAL_PDF_LOADED_SUCCESS: {
                draft.isDealPdfLoading = action.payload;
                break;
            }
            case FETCH_DEAL_SUCCESS: {
                draft.dealPdfUrl = '';
                break;
            }
            default:
                break;
        }
    });
